import { connect } from 'react-redux';
import layoutModule from 'app/store/layout';
import paymentModule from 'app/store/payment';
import orderModule from 'app/store/order';
import bookingsModule from 'app/store/bookings';
import BookingSuccess from './BookingSuccess.component';

const { clearErrorApi, setLoader } = layoutModule.actions;
const { purchaseStatusRequest, purchaseRequest } = paymentModule.actions;
const { clearOrder } = orderModule.actions;
const mapStateToProps = ({ layout: { apiError }, bookings: { booking } }) => (
  {
    error: apiError,
    booking: booking
  });

const mapDispatchToProps = {
  clearErrorApi,
  fetchPurchase: purchaseStatusRequest,
  fetchTickets: purchaseRequest,
  setLoaderData: setLoader,
  clearOrder
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BookingSuccess);
